import {
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
} from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router"
import { findActivePath, navGroups, navSlug } from "./navGroups"

/** Mobile drawer navigation: every group as a subheader with its pages beneath. */
export const NavDrawerList: FC<{ onNavigate: () => void }> = ({
  onNavigate,
}) => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const activePath = findActivePath(location.pathname)

  return (
    <List dense>
      {navGroups.map((group) => {
        const Icon = group.icon
        return (
          <li key={group.key}>
            <ul style={{ padding: 0 }}>
              <ListSubheader
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <Icon fontSize="small" />
                {t(group.labelKey)}
              </ListSubheader>
              {group.items.map((item) => {
                const isActive = item.path === activePath
                return (
                  <ListItemButton
                    key={item.path}
                    data-testid={`nav-drawer-${navSlug(item.path)}-link`}
                    selected={isActive}
                    sx={{ pl: 4 }}
                    onClick={() => {
                      navigate(item.path)
                      onNavigate()
                    }}
                  >
                    <ListItemText
                      primary={t(item.labelKey)}
                      slotProps={{
                        primary: { fontWeight: isActive ? 600 : 400 },
                      }}
                    />
                  </ListItemButton>
                )
              })}
            </ul>
          </li>
        )
      })}
    </List>
  )
}
